import Lottie from 'react-lottie-player'
//import Lottie from 'react-lottie'
//import Lottie from 'lottie-react'
import Heading from '../core/components/atoms/Heading'
//Another lottie
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

function Slide({ children, title, image, lottieSettings, lottieRef }) {
  // Default settings
  const lottieOptions = {
    loop: lottieSettings.loop || false,
    autoplay: lottieSettings.autoplay || false,
    animationData: lottieSettings.animationData,
    isClickToPauseDisabled: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }
  // Rounded with a shadow
  return (
    <div className='slide rounded-xl py-10'>
      {/* {children} */}
      <div className='grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-24 px-8 lg:px-20'>
        <div className='col-text font-shell-heavy content-center'>
          {title && (
            <Heading theme='secondary' level='2'>
              {title}
            </Heading>
          )}
          {children}
        </div>
        <div className='col-image'>
          {/* Newer files should use this. Set useDotLottie in settings */}
          {lottieSettings.useDotLottie ? (
          <DotLottieReact
            data={lottieSettings.animationData}
            loop={lottieSettings.loop || false}
            autoplay={lottieSettings.autoplay || false}
            dotLottieRefCallback={(dotLottie) => {
          lottieRef(dotLottie);
        }}
          />
      ) : (
          // Old way, use this for older files
          <Lottie
            loop={lottieSettings.loop || false}
            play={lottieSettings.autoplay || false}
            animationData={lottieSettings.animationData}
            ref={lottieRef}
          />
      )}

        </div>
      </div>
    </div>
  )
}

export default Slide
